import { useState, useEffect } from 'react';
import {
  ensureValidUri,
  getPPUrl,
  getPPAuthToken,
} from '@r-and-a-shared-ui/utils';

import { AUTH_TOKEN_KEY } from '../constants/playerPortals';

export type QueryResponse = {
  items: Array<any>;
  contact?: any;
  errorKey: string;
  httpStatusCode: number;
  successCode: string;
};

const useFetchCurrentUserData = (
  callbackUrl: string | undefined,
  apiRoute: any,
  procedureKey: string,
  userId: string | undefined,
) => {
  const [data, setData] = useState<QueryResponse | null>(null);
  const [loading, setLoading] = useState(false);
  const [hasFetched, setHasFetched] = useState(false);
  const mutation = apiRoute?.[procedureKey]?.useMutation();
  const authTokenMutation = apiRoute?.[AUTH_TOKEN_KEY]?.useMutation();

  const defaultValuesAsync = mutation?.mutateAsync;

  useEffect(() => {
    if (!callbackUrl || !userId) {
      setData(null);
      return;
    }

    const fetchData = async () => {
      setLoading(true);

      const bearerToken = await getPPAuthToken(authTokenMutation.mutateAsync);

      const fullCallbackUrl = ensureValidUri(callbackUrl, getPPUrl());

      try {
        const res = await defaultValuesAsync({
          callBackUrl: fullCallbackUrl,
          bearerToken,
          id: userId,
        });

        setData(res);
      } catch (err: any) {
        console.error('Error fetching table data:', err);
      } finally {
        setLoading(false);
        setHasFetched(true);
      }
    };

    fetchData();
  }, [callbackUrl, userId]);

  return { data, loading, hasFetched };
};

export default useFetchCurrentUserData;
